import { render, staticRenderFns } from "./ReserveTable.vue?vue&type=template&id=4f013ab0&"
import script from "./ReserveTable.vue?vue&type=script&lang=js&"
export * from "./ReserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports